export default __webpack_public_path__ + "static/media/access_disk_blank.052a175e.png";